<template>
  <div class="container-fluid">
    <div class="page-tabs">
      <a :class="{ active: currentTab === 0 }" @click.prevent="currentTab = 0">
        1111匯入
      </a>
    </div>

    <div class="function-card">
      <el-button
        v-if="tableData.length === 0"
        size="small"
        type="primary"
        data-toggle="modal"
        data-target="#commonModal"
      >
        點擊上傳
      </el-button>
      <template v-else>
        <el-button v-if="errorMessages.length === 0" size="small" type="primary" @click.stop="checkUpload">
          上傳
        </el-button>
        <el-button size="small" type="secondary" @click.stop="removeFile">
          清除
        </el-button>
      </template>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <template slot="empty">
        <span>暫無數據</span>
      </template>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="Email:">
              <span>{{ props.row.Email }}</span>
            </el-form-item>
            <el-form-item label="戶籍地址：">
              <span>{{ props.row.Address }}</span>
            </el-form-item>
            <el-form-item label="聯絡地址：">
              <span>{{ props.row.ContactAddress }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-學制：">
              <span>{{ props.row.EducationTopDegree }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-學校：">
              <span>{{ props.row.EducationTopSchool }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-學校描述：">
              <span>{{ props.row.EducationTopSchoolDescription }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-科系名稱：">
              <span>{{ props.row.EducationTopMajorName }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-就學起：">
              <span>{{ $common.dateFormatter(props.row.EducationTopFrom) }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-就學迄：">
              <span>{{ $common.dateFormatter(props.row.EducationTopTo) }}</span>
            </el-form-item>
            <el-form-item label="最高學歷-是否畢業：">
              <span>{{ props.row.EducationTopIsGraduate }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="項次" prop="RowId" width="80" />
      <el-table-column label="應徵職缺" prop="PositionName" />
      <el-table-column label="應徵日期">
        <template slot-scope="props">
          {{ $common.dateFormatter(props.row.ApplyDate) }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="Name" />
      <el-table-column label="性別" prop="Sex" />
      <el-table-column label="生日">
        <template slot-scope="props">
          {{ $common.dateFormatter(props.row.Birthday) }}
        </template>
      </el-table-column>
      <el-table-column label="市話" prop="Phone" />
      <el-table-column label="手機" prop="MobilePhone" />
      <el-table-column label="錯誤訊息">
        <template slot-scope="props">
          <el-button
            size="small"
            v-if="props.row.ErrorMessages.length > 0"
            data-toggle="modal"
            data-target="#errorMessagesModal"
            @click="errorMessages = props.row.ErrorMessages"
          >
            檢視
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 匯入資料 Modal -->
    <div
      class="modal fade"
      id="commonModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">匯入資料</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="form-group">
              <u
                style="color: midnightblue; cursor: pointer"
                @click="downloadTemplate"
              >
                點擊下載範例檔
              </u>
            </p>
            <p class="form-group">
              <span class="mark">* 檔案限制：[檔名].xlsx、[檔名].xls</span>
              <br />
              <span class="mark">* 大小限制：10MB 以下</span><br />
              <span class="mark">* 上傳前請確認是否符合格式</span><br />
            </p>
            <div class="from-group">
              <label for=""><span class="mark">*</span>檔案</label>
              <el-upload
                ref="upload"
                action
                accept=".xlsx,.xls"
                :auto-upload="false"
                :limit="1"
                :on-change="uploadFile"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">點擊上傳</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 錯誤訊息 Modal -->
    <div class="modal fade" id="errorMessagesModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <span>錯誤訊息</span>
          </div>
          <div class="modal-body">
            <div class="result-person-list" style="background: #fdd1d1">
              <div
                class="person"
                v-for="(error, index) in errorMessages"
                :key="index"
              >
                {{ error }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import ResponseDataModal from "@/components/back/Modal/ResponseData";

export default {
  name: "ImportingResumes",

  components: {
    ResponseDataModal,
  },

  data() {
    return {
      currentTab: 0,

      tableData: [],
      file: [],
      fileList: [],

      // 上傳檔案錯誤訊息
      errorMessages: [],

      // API 回應資訊
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息
    };
  },

  methods: {
    // 下載 範例檔
    downloadTemplate() {
      this.$api.c1111.getResumeTemplate().then((response) => {
        if (response.status === 200) {
          let filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    // 上傳檔案(預覽)
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }
      
      this.file = file;
      $("#commonModal").modal("hide");
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);

      this.$api.c1111.previewResume(fd).then((response) => {
        if (response.status === 200) {
          this.errorMessages = response.data
            .map((item) => item.ErrorMessages)
            .filter((data) => data.length > 0);

          if (this.errorMessages.length > 0) {
            this.$notify({
              title: "錯誤",
              message: "資料有誤",
              type: "error",
              duration: 3500,
            });
          }
          this.tableData = response.data;
        }
        this.updateLoading(false);
      });
    },

    // 確認上傳
    checkUpload() {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", this.file.raw);

      this.$api.c1111.importResume(fd).then((response) => {
        if (response.status === 200) {
          this.successMessage = response.data.SuccessMessages;
          this.failMessage = response.data.FailureMessages;
          this.$store.commit("OpenResponseDataModal", true);
        }
        this.removeFile();
        this.updateLoading(false);
      });
    },

    // 移除檔案
    removeFile() {
      this.fileList = [];
      this.tableData = [];
      this.errorMessages = [];
    },

    // loading
    ...mapActions(["updateLoading"]),
  },
};
</script>

<style lang="scss" scoped>
.el-table .warning-row {
  background: oldlace;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

/deep/ .el-form-item__label {
  padding: 0 6px 0 0;
}
.page-tabs {
  cursor: pointer;
}
#commonModal {
  .modal-header {
    .close {
      margin: -3rem -1rem -1rem auto;
    }
  }
  .modal-body {
    max-height: unset;
    overflow: unset;
  }
}
.result-person-list {
  background-color: #e4eafa;
  padding: 20px;

  &.failed {
    background-color: #fdd1d1;
  }
  .person {
    display: flex;
    color: #000;
    align-items: center;
    background: #fff;
    margin-bottom: 5px;
    padding: 5px;
    border-radius: 25px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
